import React from "react";
import {
  StyledProgressBarContainer,
  StyledProgressBarFiller,
  StyledProgressBar,
} from "./ProgressBar.styled";
import { BodyTyp } from "../../Typography/Typography";
import { theme } from "../../../constants/StyledComponents";
import { DimensionsEnum, FontWeightEnum } from "../../../types/AppTypes";

interface ProgressBarProps {
  progress: number;
  visiblePercentage?: boolean;
  color?: string;
  size?: DimensionsEnum;
}

export const ProgressBar = ({
  progress,
  visiblePercentage = true,
  color = theme.colors.green,
  size = DimensionsEnum.BIG,
}: ProgressBarProps) => {
  return (
    <StyledProgressBar>
      <StyledProgressBarContainer $size={size}>
        <StyledProgressBarFiller $progress={progress} $color={color} />
      </StyledProgressBarContainer>
      {visiblePercentage && (
        <BodyTyp
          color={theme.colors.black}
          fontWeight={FontWeightEnum.SEMIBOLD}
          variant="3"
        >
          {progress}%
        </BodyTyp>
      )}
    </StyledProgressBar>
  );
};
